import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Outlet } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { muiTheme } from '@setvi/shared/styles';
import CustomSnackbarProvider from 'Providers/CustomSnackbar';
import { AppProvider } from 'Providers/AppProvider';
import ReactFavicon from 'react-favicon';
import { ReactQueryProvider } from 'Providers/ReactQuery';
import 'react-virtualized/styles.css'; // only needs to be imported once

import { DataDogProvider } from 'providersV2/data-dog';
import { logVersionInfo } from './Utils/appVersion';
import './App.css';

logVersionInfo();

const App = () => (
  <ThemeProvider theme={muiTheme}>
    <Auth0Provider
      domain={
        window.location.origin.includes('middleby')
          ? process.env.AUTH0_DOMAIN_MIDDLEBY
          : process.env.AUTH0_DOMAIN
      }
      clientId={
        window.location.origin.includes('middleby')
          ? process.env.AUTH0_CLIENTID_MIDDLEBY
          : process.env.AUTH0_CLIENTID
      }
      authorizationParams={{
        redirect_uri: `${window.location.origin}/token-callback`,
        connection: window.location.origin.includes('middleby')
          ? process.env.AUTH0_REALM_MIDDLEBY
          : process.env.AUTH0_REALM,
        scope: 'openid name email'
      }}
      authorizeTimeoutInSeconds={300}>
      <CustomSnackbarProvider>
        <ReactQueryProvider>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AppProvider>
              <DataDogProvider>
                <Outlet />
                <ReactFavicon url="/icons/favicon.ico" />
                {process.env.NODE_ENV === 'development' ? (
                  <ReactQueryDevtools />
                ) : null}
              </DataDogProvider>
            </AppProvider>
          </QueryParamProvider>
        </ReactQueryProvider>
      </CustomSnackbarProvider>
    </Auth0Provider>
  </ThemeProvider>
);

export default App;
